/* eslint-disable */
import React, { useState } from "react";
import styled from "styled-components";
import EditTruck from "./editTruck";
import { ModalComponent, ModalHeader, ToastMessage } from "components";

const TruckId = styled.span`
    color: rgba(0, 107, 180, 1);
    font-size: 20px;
    font-weight: 700;
    margin-left: 22px;
`;
const TruckHeader = styled.span`
    width: 100%;
    font-size: 1.6rem;
    font-weight: 700;
    color: #111827;
`;

function EditTruckModal({
    showEditTruckModal,
    selectedTruckId,
    handleCloseEditTruckModal,
    setShowEditTruckModal,
    isSuppliersEntity,
    qaStatus,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [plateNumber, setPlateNumber] = useState(null);

    const onSuccess = (plateNumber) => {
        setShowEditTruckModal(false);
        setPlateNumber(plateNumber);
        setShowSuccessMessage(true);
    };

    return (
        <>
            <ModalComponent
                open={showEditTruckModal}
                size="large"
                borderedHeader
                header={
                    <ModalHeader
                        entityName="Edit Truck"
                        entityId={selectedTruckId}
                        entityStatus={qaStatus}
                    />
                }
                onClose={handleCloseEditTruckModal}
            >
                <EditTruck
                    onClose={handleCloseEditTruckModal}
                    setShowEditTruckModal={setShowEditTruckModal}
                    selectedTruckId={selectedTruckId}
                    onSuccess={onSuccess}
                    isSuppliersEntity={isSuppliersEntity}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={plateNumber}
                    text="info edits have been submitted successfully."
                />
            )}
        </>
    );
}

export default EditTruckModal;
